import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ceb89194&scoped=true&lang=html&"
import script from "./confirmOrder.js?vue&type=script&lang=js&"
export * from "./confirmOrder.js?vue&type=script&lang=js&"
import style0 from "./confirmOrder.styl?vue&type=style&index=0&id=ceb89194&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb89194",
  null
  
)

export default component.exports